import WebVolcengine from "./web" // web 端
import UniVolcengine from "./uni-app" // uni-app

let analysisClass
// #ifdef APP-PLUS
analysisClass = UniVolcengine
// #endif

// #ifndef APP-PLUS
analysisClass = WebVolcengine
// #endif

export default analysisClass
